import { IBaseModel } from '../../../Interface/base/base-model.interface';
import { IShapeModel } from '../../../Interface/shape-model.interface';
import { UIModelType } from '../../../constant';
import { FillType } from '../fill.interface';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';

/**
 * 返回设置图片填充的形状，图片是否可设置
 */
export function isImageConfigurableForShapeImageFill(model: IBaseModel): boolean {
    const selectedModel = getSelectionService().getSelectedModel();
    const isMultiSelected = selectedModel?.type === UIModelType.MULTIPLY;
    if (model.type === UIModelType.SHAPE) {
        // 在多选的情况下，获取mode的实际填充类型。
        const fillType = isMultiSelected
            ? (model as IShapeModel).getBackgroundFill().getShownFillType()
            : (model as IShapeModel).getBackgroundFill().getFillType();
        if (fillType === FillType.ImageFill && !(model as IShapeModel).isTextMath) {
            return true;
        }
    }
    return false;
}

function getSelectionService() {
    return (AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices)
        .viewableServiceLayer?.selectionService;
}
